export const ROLE_CC = 'ROLE_CC';
export const ROLE_CC_C = 'ROLE_CC_C';
export const ROLE_CC_R = 'ROLE_CC_R';
export const ROLE_CC_U = 'ROLE_CC_U';

export const ROLE_CR = 'ROLE_CR';
export const ROLE_CR_C = 'ROLE_CR_C';
export const ROLE_CR_R = 'ROLE_CR_R';
export const ROLE_CR_U = 'ROLE_CR_U';
export const ROLE_CR_ATT = 'ROLE_CR_ATT';
export const ROLE_USR_AGT = 'ROLE_USR_AGT';

export const ROLE_USR = 'ROLE_USR';
export const ROLE_USR_R = 'ROLE_USR_R';
export const ROLE_USR_C = 'ROLE_USR_C';
export const ROLE_USR_U = 'ROLE_USR_U';
export const ROLE_USR_D = 'ROLE_USR_D';
export const ROLE_USR_CMT_R = 'ROLE_USR_CMT_R';
export const ROLE_USR_CMT_R_MY = 'ROLE_USR_CMT_R_MY';
export const ROLE_USR_CMT_C = 'ROLE_USR_CMT_C';
export const ROLE_USR_CMT_C_MY = 'ROLE_USR_CMT_C_MY';
export const ROLE_USR_REC = 'ROLE_USR_REC';
export const ROLE_USR_REC_C = 'ROLE_USR_REC_C';
export const ROLE_USR_REC_U = 'ROLE_USR_REC_U';

export const ROLE_CONTROL = 'ROLE_CONTROL';

export const ROLE_CHT_R = 'ROLE_CHT_R';
export const ROLE_CHT_R_MY = 'ROLE_CHT_R_MY';
export const ROLE_CHT_C = 'ROLE_CHT_C';
export const ROLE_CHT_C_MY = 'ROLE_CHT_C_MY';

export const ROLE_PRF_CUD = 'ROLE_PRF_CUD';

export const ROLE_TODO_R = 'ROLE_TODO_R';
export const ROLE_TODO_CUD = 'ROLE_TODO_CUD';

export const ROLE_QC_IND = 'ROLE_QC_IND';
export const ROLE_QC_CRUD = 'ROLE_QC_CRUD';

export const ROLE_ABS = 'ROLE_ABS';
export const ROLE_ABS_CLOSE = 'ROLE_ABS_CLOSE';